import React from "react"
import style from "./summary.module.css"
import AppStoreButton from "./appstore-button"

const SummaryText = () => {
  
  return (
    <div className="boxwrapper">
      <div className={style.summarytext}>
        <div className={style.text}>Itemio is a FREE inventory app that helps you 
        know what items you have and where they are stored. 
        </div>
        <p>Only available on:</p>
        <AppStoreButton/>
      </div>
    </div>
  )
}

export default SummaryText
